<template>
  <div id="app">
    <SideNav v-if="showSideNav" />
    <router-view class="main"/>
    <snack-bar
      v-for="(s, index) in $store.state.snackBar.messages"
      :key="index"
      :index="index">
    </snack-bar>
  </div>
</template>

<script>
import SideNav from '@/components/SideNav'
import SnackBar from '@/components/SnackBar'

export default {
  components: {
    SideNav,
    SnackBar
  },

  created: async function () {
    await this.$store.dispatch('option/retrieveOptions')
  },

  computed: {
    showSideNav: function () {
      return this.$route.meta.sideNav
    }
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
}

#app {
  display: flex;
  color: $wet-asphalt;
}

.main {
  width: 100vw;
  height: 100vh;
  overflow: scroll;
}
</style>
